import { z } from 'zod';
import { SalesRole } from '../enums.js';
export const SalesUserSummary = z.object({
    id: z.string().uuid(),
    tenantId: z.string().uuid().nullable(),
    name: z.string(),
    email: z.string().email(),
    role: SalesRole,
    onlineStatus: z.enum(['online', 'offline', 'away']),
    lastSeenAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
});
export const CreateSalesUserRequest = z.object({
    name: z.string().min(1).max(100),
    email: z.string().email(),
    password: z.string().min(8).max(200),
    role: SalesRole.default('sales'),
});
export const UpdateSalesUserRequest = z
    .object({
    name: z.string().min(1).max(100).optional(),
    role: SalesRole.optional(),
    /** When set, replaces the password. Server re-hashes. */
    password: z.string().min(8).max(200).optional(),
})
    .refine((v) => v.name !== undefined || v.role !== undefined || v.password !== undefined, { message: 'at least one of name/role/password must be provided' });
//# sourceMappingURL=sales-user.js.map